import { useCallback, useEffect, useState } from "react";

import { Key, Trash } from "lucide-react";
import { Button, List, ListItem, Badge, FormCard, ButtonIcon } from "twyne-new.ui";

import { useTokenStore } from "@Modules/settings/views/token/store";
import { formatDateTime } from "@Utils/index";

export default function ActiveSessions() {
  const { session: { getSession, deleteSessions }, collection: { deleteEntry } } = useTokenStore()
  const [sessions, setSessions] = useState([])
  const [total, setTotal] = useState(0)
  const [bulkDelete, setBulkDelete] = useState({})

  const loadData = useCallback(async () => {
    const data = await getSession()
    setSessions(data?.rows);
    setTotal(data?.total);
  }, [getSession])

  useEffect(() => {
    loadData()
  }, [loadData])

  async function handleDeleteSession(session) {
    await deleteEntry(session)
    await loadData()
  }

  function handleClickSession(session) {
    if (bulkDelete[session.id]) {
      const newSessions = { ...bulkDelete }
      delete newSessions[session.id]
      setBulkDelete(newSessions)

      return
    }

    setBulkDelete(prevSessions => ({ ...prevSessions, [session.id]: session.id }))
  }

  async function handleClickBulkDelete() {
    await deleteSessions(Object.keys(bulkDelete))
    setBulkDelete({})
    await loadData()
  }

  async function handleClickSelectAll() {
    setBulkDelete(sessions.reduce((bulkDelete, currentSesison) => ({ ...bulkDelete, [currentSesison.id]: currentSesison.id }), {}))
  }

  const isDeleteGroup = JSON.stringify(bulkDelete) !== "{}"

  return <>
    <Header
      total={total}
      isDeleteGroup={isDeleteGroup}
      finalizeCount={Object.keys(bulkDelete).length}
      handleClickBulkDelete={handleClickBulkDelete}
      handleClickSelectAll={handleClickSelectAll}
    >
      <List border className='h-[19vh] overflow-y-auto px-0!'>
        {sessions.map((session, idx) => <SessionItem
          key={idx}
          session={session}
          selected={!!bulkDelete[session.id]}
          onClick={() => handleClickSession(session)}
          onDeleteSession={() => handleDeleteSession(session)}
        />)}
      </List>
    </Header>
  </>
}

const SessionItem = ({ session, selected, onClick, onDeleteSession }) => <>
  <ListItem selected={selected} className='flex justify-between items-center' onClick={onClick}>
    <span>Logged in: {formatDateTime(session.created_at)}</span>
    <div className='flex items-center gap-2'>
      <ButtonIcon content={session.id}>
        <Key size='16' />
      </ButtonIcon>
      <ButtonIcon content='Finalize session' onClick={onDeleteSession}>
        <Trash size='16' />
      </ButtonIcon>
    </div>
  </ListItem>
</>

const Header = ({ total, isDeleteGroup, finalizeCount, handleClickBulkDelete, handleClickSelectAll, children }) => <>
  <FormCard
    title={<div className='flex items-center gap-2'>
      Active Sessions
      <Badge className='self-center' size='sm' color='accent' variant='light'>Total: {total}</Badge>
    </div>}
    headerButtons={<>
      {isDeleteGroup ? <>
        <Button className='text-base' size='sm' variant='outline' color='accent' onClick={handleClickBulkDelete}>
          Finalize Sessions: <span className='font-extrabold'> {finalizeCount}</span>
        </Button>
      </> : <>
        <Button className='text-base' size='sm' variant='outline' color='accent' onClick={handleClickSelectAll}>
          Select All
        </Button>
      </>}
    </>}
  >
    {children}
  </FormCard>
</>
